var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0527 12.3711C19.0527 12.5169 18.9954 12.6471 18.8809 12.7617L13.6152 18.0273C13.5007 18.1367 13.373 18.1914 13.2324 18.1914C13.0866 18.1914 12.9642 18.1419 12.8652 18.043C12.7715 17.9492 12.7246 17.832 12.7246 17.6914C12.7246 17.6185 12.735 17.5482 12.7559 17.4805C12.7767 17.4128 12.8105 17.3581 12.8574 17.3164L15.209 14.9414L17.873 12.4727L17.998 12.7852L15.6934 12.8945H5.06055C4.90951 12.8945 4.78451 12.8451 4.68555 12.7461C4.5918 12.6471 4.54492 12.5221 4.54492 12.3711C4.54492 12.2201 4.5918 12.0951 4.68555 11.9961C4.78451 11.8971 4.90951 11.8477 5.06055 11.8477H15.6934L17.998 11.957L17.873 12.2773L15.209 9.80078L12.8574 7.42578C12.8105 7.37891 12.7767 7.32422 12.7559 7.26172C12.735 7.19401 12.7246 7.1237 12.7246 7.05078C12.7246 6.91016 12.7715 6.79297 12.8652 6.69922C12.9642 6.60026 13.0866 6.55078 13.2324 6.55078C13.3053 6.55078 13.3757 6.56641 13.4434 6.59766C13.5111 6.6237 13.5814 6.67578 13.6543 6.75391L18.8809 11.9805C18.9954 12.0898 19.0527 12.2201 19.0527 12.3711Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.a1672a2a.svg";
export { ForwardRef as ReactComponent };